

<abp-page title="Profile">
  
  <div class="row">
  <div class="col-md-6">
      
    <div class="mt-3 p-3 card tab-pane fade active show">
          
      <div class="mb-3 form-group">
        <label for="input-user-name" class="form-label">User Name</label>
        <input type="text" id="input-user-name" class="form-control"
            [value]="currentUser.userName" readonly />
      </div>
      <div class="row">
        <div class="col-md-6 mb-3 form-group">
          <label for="input-first-name" class="form-label">First Name</label>
          <input type="text" id="input-first-name" class="form-control"
              [value]="currentUser.name" readonly />
        </div>
        <div class="col-md-6">
          <label for="input-last-name" class="form-label">Last Name</label>
          <input type="text" id="input-last-name" class="form-control"
              [value]="currentUser.surName" readonly />
        </div>
      </div>
      <div class="mb-3 form-group">
        <label for="input-email" class="form-label">Email</label>
        <input autofocus type="text" id="input-email" class="form-control"
            [value]="currentUser.email" readonly />

        
      </div>
      <div class="mb-3 form-group">
        <input type="checkbox" id="input-email-verified" class="form-control-check" 
          [checked]="currentUser.emailVerified" readonly />
        <label for="input-email-verified" class="form-label">Email Verified</label>
        
        
      </div>
      <div class="mb-3 form-group">
        <label for="input-phone" class="form-label">Phone Number</label>
        <input autofocus type="text" id="input-phone" class="form-control"
            [value]="currentUser.phoneNumber" readonly />

        
      </div>
     
  </div>
    
  </div>
  <div class="col-md-4">
    <div class="card mt-3 p-3">
      <ngx-datatable [rows]="roles">
        <ngx-datatable-column name="Roles" [headerTemplate]="hdrTpl" [sortable]="false" >
          
        </ngx-datatable-column>
      </ngx-datatable>

      <ng-template #hdrTpl let-column="column"> <strong>Granted Roles</strong> </ng-template>
    </div>
  </div>
</div>


</abp-page>

